import { arrayMove } from 'common/utilities/core/array';
import type { SequenceAlign } from 'sequenceAnalyser/api/sequenceAnalyserApiClient';

export function moveSequencesToTop(sequences: SequenceAlign[], ids: number[]) {
  const selectedSequences = sequences.filter((s) => ids.includes(s.id));
  const otherSequences = sequences.filter((s) => !ids.includes(s.id));
  return [...selectedSequences, ...otherSequences];
}

export function moveSequenceUp(sequences: SequenceAlign[], id: number) {
  const index = sequences.findIndex((s) => s.id === id);

  if (index - 1 > 0) {
    return arrayMove(sequences, index, index - 1);
  }
  return sequences;
}

export function moveSequenceDown(sequences: SequenceAlign[], id: number) {
  const index = sequences.findIndex((s) => s.id === id);

  if (index + 1 < sequences.length) {
    return arrayMove(sequences, index, index + 1);
  }
  return sequences;
}

export function moveSequenceTo(
  sequences: SequenceAlign[], fromPosition: number, toPosition: number,
) {
  return arrayMove(sequences, fromPosition, toPosition);
}
